<template>
  <v-card class="ma-1">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="data"
        dense
        disable-pagination
        hide-default-footer
      >
        <template #item.name="{item}">
          <code><span v-if="item.rest">...</span>{{item.name}}</code>
        </template>
        <template #item.description="{item}">
          <markdown
            v-if="item.description"
            :source="item.description"
          />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>

</template>

<script>
import Markdown from '@/components/Markdown';

export default {
  name: 'ParamsTable',
  components: {Markdown},
  props: {
    data: Array,
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Type', value: 'type'},
        {text: 'Description', value: 'description'},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
